import { useMutation } from 'react-query';

import { googleLogin } from '../../lib/api';

export function useMutateGoogleLogin() {
  return useMutation(googleLogin);
}
